import { Button, Icon, Input, Modal, Typography } from '@smartgift/frontend-toolkit';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_DOMAIN_LENGTH } from '@hero/constants';
import { DetailItem } from '@hero/molecules';
import { isValidDomain } from '@hero/utils/validationUtils';

import * as S from './style';

function AddDomainModal({ openModal, previousAuthorizedDomains = [], onSave, onRequestClose }) {
  const { t } = useTranslation();
  const [emailDomains, setEmailDomains] = useState([]);

  function addNewDomain(emailDomain) {
    return setEmailDomains([...emailDomains, emailDomain]);
  }

  const domainsIsValid = useMemo(() => {
    return (
      emailDomains.filter(emailDomain => !isValidDomain(emailDomain) && emailDomain !== '')
        .length === 0
    );
  }, [emailDomains]);

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={onRequestClose}
      title={t('addDomain')}
      primaryButtonProps={{
        children: t('save'),
        onClick: () => onSave(emailDomains),
        disabled: !domainsIsValid || (emailDomains.length === 1 && emailDomains[0] === '')
      }}
      secondaryButtonProps={{
        children: t('cancel')
      }}
      size="sm"
    >
      <S.DomainManagementWrapper>
        <Typography variant="body1Bold">{t('onlyEmailSpecifiedDomain')}</Typography>

        <S.AuthorizedDomainWrapper>
          <DetailItem title={`${t('previouslyAuthorizedDomains')}:`}>
            {previousAuthorizedDomains.map(domain => {
              return (
                <Typography variant="body3" key={domain}>
                  {domain}
                </Typography>
              );
            })}
          </DetailItem>
        </S.AuthorizedDomainWrapper>
        {emailDomains.map((emailDomain, index) => {
          const isValid = emailDomains[index] === '' || isValidDomain(emailDomains[index]);
          return (
            <S.EmailDomainArea key={index}>
              <Input
                variant="outlined"
                value={emailDomain}
                size="lg"
                label={t('domainName')}
                error={!isValid}
                helperText={!isValid && t('domainIsNotValid')}
                onChange={e => {
                  emailDomains[index] = e.target.value;
                  setEmailDomains([...emailDomains]);
                }}
                inputProps={{ maxLength: MAX_DOMAIN_LENGTH }}
              />
              <Button
                variant="text"
                style={{ gap: 4 }}
                startIcon={<Icon name="delete" px="15px" color="var(--color-error-default)" />}
                disabled={!emailDomains[index] && emailDomains.length === 1}
                onClick={() => {
                  if (emailDomains.length <= 1) {
                    setEmailDomains(['']);
                  } else {
                    setEmailDomains(emailDomains.filter((_e, i) => index !== i));
                  }
                }}
              >
                <Typography color="error" emphasis="500" variant="body5Bold">
                  {t('remove')}
                </Typography>
              </Button>
            </S.EmailDomainArea>
          );
        })}

        <Button
          variant="text"
          startIcon={<Icon name="add" px="14px" />}
          onClick={() => addNewDomain('')}
        >
          {t('addADomain')}
        </Button>
      </S.DomainManagementWrapper>
    </Modal>
  );
}

export { AddDomainModal };
